import view from './view.js';

export {view};


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/wordBank/index.js